import React from 'react'
import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const IconReload = ({
  className,
  'data-mu-test': dataAttributeTest
}) => {
  return (
    <IconSLIWrapper className={className} data-mu-test={dataAttributeTest}>
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 24 24'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M17.118,20.350 C16.662,20.662 16.040,20.543 15.729,20.087 C15.418,19.631 15.535,19.008 15.991,18.697 C18.427,17.037 20.000,14.017 20.000,11.003 C20.000,6.039 15.962,2.001 11.000,2.001 C6.038,2.001 2.000,6.039 2.000,11.003 C2.000,15.764 5.717,19.664 10.399,19.975 L8.979,17.494 C8.706,17.015 8.872,16.404 9.351,16.130 C9.831,15.855 10.441,16.021 10.716,16.501 L12.868,20.263 C13.001,20.495 13.035,20.770 12.964,21.027 C12.893,21.285 12.721,21.503 12.488,21.633 L8.488,23.872 C8.334,23.959 8.166,24.000 8.001,24.000 C7.650,24.000 7.311,23.815 7.127,23.488 C6.857,23.006 7.030,22.396 7.512,22.127 L8.334,21.666 C3.555,20.469 0.000,16.149 0.000,11.003 C0.000,4.936 4.935,0.000 11.000,0.000 C17.065,0.000 22.000,4.936 22.000,11.003 C22.000,14.659 20.084,18.328 17.118,20.350 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

IconReload.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string
}
